import React, { useState, useRef } from 'react';
import { ArrowLeft } from 'lucide-react';
import ApiCheckout from '../../adapters/apiCheckout';
import StandaloneLayout from '../../components/terminal/layouts/StandaloneLayout';
import { STANDALONE_CONFIG } from '../../components/terminal/shared/TerminalConfig';
import InsertCard from '../../components/terminal/shared/InsertCard';
import EnterAmount from '../../components/terminal/shared/EnterAmount';
import InsertTapCard from '../../components/terminal/shared/InsertTapCard';
import EnterPin from '../../components/terminal/shared/EnterPin';
import Verifying from '../../components/terminal/shared/Verifying';
import VerificationComplete from '../../components/terminal/shared/VerificationComplete';
import Receipt from '../../components/terminal/shared/Receipt';
import ReceiptDetail from '../../components/terminal/shared/ReceiptDetail';
import PrintingReceipt from '../../components/terminal/shared/PrintingReceipt';
import ThankYou from '../../components/terminal/shared/ThankYou';

export default function StandaloneTerminal() {
    const [currentScreen, setCurrentScreen] = useState('insert-card');
    const [transactionResponse, setTransactionResponse] = useState(null);
    const [amountValueCaptured, setAmount] = useState(null);
    const apiCheckout = useRef(new ApiCheckout());

    const handleCardClick = () => setCurrentScreen('enter-pin');
    const handleEnterAmount = () => setCurrentScreen('enter-amount');
    const handlePinCancel = () => setCurrentScreen('insert-card');

    const handleAmountSubmit = async (amount) => {
        setCurrentScreen('insert-tap-card');
        setAmount(amount);
        console.log('Amount captured:', amount);
    };

    const handleCardDetected = () => {
        setCurrentScreen('enter-pin');
    };

    const handlePinSubmit = async (pin) => {
        console.log('handlePinSubmit called with PIN:', pin);
        console.log('Amount value captured:', amountValueCaptured);
        setCurrentScreen('verifying');
        
        try {
            const response = await apiCheckout.current.createTerminalSale(amountValueCaptured);
            console.log('Terminal sale response:', response);
            handleVerificationComplete({ successful: true, ...response });
        } catch (error) {
            console.error('Terminal sale error:', error);
            const errorObj = typeof error === 'object' && error !== null ? error : {};
            handleVerificationComplete({ successful: false, ...errorObj });
        }
    };

    const handleVerificationComplete = (response) => {
        setTransactionResponse(response);
        setCurrentScreen('verification-complete');
    };

    const handleVerificationTimeout = () => {
        setCurrentScreen('receipt');
    };

    const handleVerificationCancel = () => setCurrentScreen('insert-card');
    const handleYesClick = () => setCurrentScreen('printing-receipt');
    const handleNoClick = () => setCurrentScreen('thank-you');
    const handleContinue = () => setCurrentScreen('thank-you');
    const handleEmail = () => {
        // TODO: Implement email receipt functionality
        console.log('Email receipt requested');
        setCurrentScreen('thank-you'); // For now, go to thank you screen
    };
    
    const handleSms = () => {
        // TODO: Implement SMS receipt functionality
        console.log('SMS receipt requested');
        setCurrentScreen('thank-you'); // For now, go to thank you screen
    };
    
    const handlePrintingComplete = () => setCurrentScreen('thank-you');
    const handleNewTransaction = () => {
        setCurrentScreen('insert-card');
        setTransactionResponse(null);
        setAmount(null);
    };

    const renderCurrentScreen = () => {
        switch (currentScreen) {
            case 'insert-card':
                return <InsertCard onCardClick={handleCardClick} onEnterAmount={handleEnterAmount} config={STANDALONE_CONFIG} />;
            case 'enter-amount':
                return <EnterAmount onCancel={handlePinCancel} onSubmit={handleAmountSubmit} config={STANDALONE_CONFIG} />;
            case 'insert-tap-card':
                return <InsertTapCard amount={amountValueCaptured} onCardDetected={handleCardDetected} config={STANDALONE_CONFIG} />;
            case 'enter-pin':
                return <EnterPin onCancel={handlePinCancel} onSubmit={handlePinSubmit} amount={amountValueCaptured} config={STANDALONE_CONFIG} />;
            case 'verifying':
                return <Verifying config={STANDALONE_CONFIG} />;
            case 'verification-complete':
                return <VerificationComplete onCancel={handleVerificationCancel} onTimeout={handleVerificationTimeout} amount={amountValueCaptured} config={STANDALONE_CONFIG} />;
            case 'receipt':
                return <Receipt onYes={handleYesClick} onNo={handleNoClick} onEmail={handleEmail} onSms={handleSms} amount={amountValueCaptured} config={STANDALONE_CONFIG} />;
            case 'printing-receipt':
                return <PrintingReceipt onComplete={handlePrintingComplete} amount={amountValueCaptured} config={STANDALONE_CONFIG} />;
            case 'receipt-detail':
                return <ReceiptDetail transaction={transactionResponse} amount={amountValueCaptured} onContinue={handleContinue} config={STANDALONE_CONFIG} />;
            case 'thank-you':
                return <ThankYou onNewTransaction={handleNewTransaction} config={STANDALONE_CONFIG} />;
            default:
                return <InsertCard onCardClick={handleCardClick} onEnterAmount={handleEnterAmount} config={STANDALONE_CONFIG} />;
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 p-4">
            <StandaloneLayout>
                {renderCurrentScreen()}
            </StandaloneLayout>
        </div>
    );
}